import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
    ArrowLeft,
    Loader2,
} from "lucide-react";

import { getOrderById } from "../services/adminApi";

import OrderHero from "../components/orders/OrderHero";
import OrderTabs from "../components/orders/OrderTabs";
import OrderActions from "../components/orders/OrderActions";

import "../css/OrderDetails.css";

function OrderDetails() {

    const { id } = useParams();

    const navigate = useNavigate();

    const [order, setOrder] = useState(null);

    const [loading, setLoading] = useState(true);

    const loadOrder = async () => {

        try {

            setLoading(true);

            const res = await getOrderById(id);

            setOrder(res.data.order);

        }

        catch (error) {

            console.error(error);

        }

        finally {

            setLoading(false);

        }

    };

    useEffect(() => {

        loadOrder();

    }, [id]);

    if (loading) {

        return (

            <div className="order-details-loading">

                <Loader2
                    size={46}
                    className="spin"
                />

                <p>

                    Loading Order Details...

                </p>

            </div>

        );

    }

    if (!order) {

        return (

            <div className="order-details-loading">

                <h2>

                    Order Not Found

                </h2>

            </div>

        );

    }

    return (

        <div className="order-details-page">

            {/* ============================= */}

            <div className="order-details-header">

                <button
                    className="back-btn"
                    onClick={() => navigate(-1)}
                >

                    <ArrowLeft size={18} />

                    Back

                </button>

                <div>

                    <h1>

                        Order Details

                    </h1>

                    <p>

                        Complete information about Order #

                        {order.orderNumber}

                    </p>

                </div>

            </div>

            {/* ============================= */}

            <OrderHero order={order} />

            {/* ============================= */}

          

            {/* ============================= */}

            <OrderTabs order={order} />
  <OrderActions

                order={order}

                refreshOrder={loadOrder}

            />
        </div>

    );

}

export default OrderDetails;